import { Grid } from "@material-ui/core"
import Container from '../../components/layout/Container'
import BoasVindas from "../../components/data_display/BoasVindas"
import Card from "../../components/Surfaces/Card"
import ImgEmail from '../../assets/img/email.png'
import PrivateRoute from '../../auth/private-route'
import ImgAcessoGestor from '../../assets/img/enterprise.png'
import ImgLiberaAccess from '../../assets/img/access.png'
import ImgGerenciaPerfis from '../../assets/img/password-code.png'
import { useAuth } from 'react-oidc-context'
import webConfig from '../../webconfig.json'
import React, { useEffect } from 'react'

export default function Dashboard(props) {
  const auth = useAuth()

  useEffect(() => {
  }, [auth.isAuthenticated, auth.user])

  class CarregaCards extends React.Component {
    render() {
      return (
        <>
          {auth &&
            auth.user &&
            auth.user.profile &&
            auth.user.profile.role.find((type) => type === 'TCOM-JRSD-GST') === undefined &&
            auth.user.profile.role.find((type) => type === 'TCOM-JRSD-GAC') === undefined &&
            auth.user.profile.role.find((type) => type === 'TCOM-JRSD-OPA') === undefined &&
            auth.user.profile.role.find((type) => type === 'TCOM-JRSD-OPL') === undefined &&
            auth.user.profile.role.find((type) => type === 'TCOM-TCE-ADM') === undefined &&
            auth.user.profile.role.find((type) => type === 'TCOM-TCE-COM') === undefined &&
            auth.user.profile.role.find((type) => type === 'TCOM-TCE-TRI') === undefined && (
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <Card
                  image={ImgAcessoGestor}
                  title="Acesso do Gestor Jurisdicionado"
                  description="Solicitação de acesso do gestor de Órgão Jurisdicionado ao sistema TCE-Comunica."
                  link={`/Solicitacao/`}
                />
              </Grid>
            )
          }
          {
            auth &&
            auth.user &&
            auth.user.profile.role.find((type) =>
              type === 'TCOM-TCE-ADM' ||
              type === 'TCOM-TCE-COM') !== undefined && (
              <>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <Card
                    image={ImgEmail}
                    title="Comunicações"
                    description="Acompanhamento dos ofícios emitidos pelo TCE-GO para os órgãos jurisdicionados."
                    link={`/AcompanhamentoComunicacoes/`}
                  />
                </Grid>
              </>
            )
          }
          {
            auth &&
            auth.user &&
            auth.user.profile.role.find((type) =>
              type === 'TCOM-JRSD-GST' ||
              type === 'TCOM-JRSD-GAC' ||
              type === 'TCOM-JRSD-OPA' ||
              type === 'TCOM-JRSD-OPL') !== undefined && (
              <>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                  <Card
                    image={ImgEmail}
                    title="Minhas Comunicações"
                    description="Ofícios emitidos pelo TCE-GO para o órgão."
                    link={`/MinhasComunicacoes/`}
                  />
                </Grid>
              </>
            )
          }

          {auth &&
            auth.user &&
            auth.user.profile.role.find((type) => type === 'TCOM-TCE-ADM' || type === 'TCOM-TCE-TRI') !== undefined && (
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <Card
                  image={ImgLiberaAccess}
                  title="Controle de Acesso TCE-GO"
                  description="Possibilita dar manutenção nas solicitações de acesso dos gestores."
                  link={`/Triagem`}
                />
              </Grid>
            )
          }

          {auth &&
            auth.user &&
            (auth.user.profile.role.find((type) => type === 'TCOM-TCE-ADM') !== undefined ||
              auth.user.profile.role.find((type) => type === 'TCOM-JRSD-GST') !== undefined ||
              auth.user.profile.role.find((type) => type === 'TCOM-JRSD-GAC') !== undefined) && (
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <Card
                  image={ImgGerenciaPerfis}
                  title="Gerenciar Perfis"
                  description="Possibilita gerenciar o acesso dos seus subordinados."
                  link={`/GerenciaPerfis`}
                />
              </Grid>
            )
          }
        </>
      )
    }
  }

  return (
    <PrivateRoute rolesAllowed={props.roles}>
      <Container
        title={webConfig.nomeApresentavelSistema}>
        <div id="ContainerPage">
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BoasVindas />
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <CarregaCards />
          </Grid>
        </div>
        <br /><br /><br /><br />
      </Container >
    </PrivateRoute>
  )
}